var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLavaEventMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 399 279.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m399,0v276.08c-.91.07-1.84.1-2.77.1-20.73,0-37.54-16.81-37.54-37.55v-111.56c0-19.8-16.05-35.85-35.85-35.85s-35.85,16.05-35.85,35.85v33.49c0,19.88-16.12,36-36.01,36s-36-16.12-36-36v-36.74c0-18-14.6-32.6-32.6-32.6s-32.61,14.6-32.61,32.6v116.13c0,21.59-17.5,39.1-39.09,39.1s-39.1-17.51-39.1-39.1v-112.73c0-19.88-16.12-36-36-36-18,0-32.91,13.21-35.58,30.46V0h399Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavaEventMob);
export default __webpack_public_path__ + "static/media/lava_event_mob.8c7f5d30e4d241751b8a709f7d3050f4.svg";
export { ForwardRef as ReactComponent };